import React, { useState } from 'react';
import { login, storeSession } from '../api';
import PasswordInput from '../components/PasswordInput';

export default function LoginPage({ onLogin }) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    // W-053 step 3a.2: the password field is the ONE PasswordInput (show / hide); a successful sign-in hides it again.
    const [hideSignal, setHideSignal] = useState(0);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            const res = await login(email, password);
            // W-053: the user is stored as the server returns it (must_change_password included); a login that must set
            // a new password lands on the forced "Set your new password" screen (App.js).
            storeSession(res.data.token, res.data.user);
            setHideSignal(n => n + 1);
            onLogin(res.data.user);
        } catch (err) {
            // W-053 step 3a: the server's own message -- 'Invalid credentials' (401) or the 429 lockout -- stays on this page;
            // api.js no longer signs out and reloads on the login's own refusal.
            setError(err.response?.data?.error || 'Login failed');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#f0f2f5'
        }}>
            <div style={{
                background: '#fff',
                borderRadius: 8,
                padding: 40,
                width: 380,
                boxShadow: '0 2px 12px rgba(0,0,0,0.1)'
            }}>
                <h1 style={{ margin: '0 0 8px', fontSize: 24, color: '#1A1C2E' }}>
                    Finledom
                </h1>
                <p style={{ margin: '0 0 24px', color: '#666', fontSize: 14 }}>
                    Sign in to your account
                </p>

                {error && (
                    <div style={{
                        background: '#fee', color: '#c00', padding: '8px 12px',
                        borderRadius: 4, marginBottom: 16, fontSize: 13
                    }}>
                        {error}
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <div style={{ marginBottom: 16 }}>
                        <label style={{ display: 'block', marginBottom: 4, fontSize: 13, color: '#333' }}>
                            Email
                        </label>
                        <input
                            type="text"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            required
                            style={{
                                width: '100%', padding: '8px 12px', border: '1px solid #ddd',
                                borderRadius: 4, fontSize: 14, boxSizing: 'border-box'
                            }}
                        />
                    </div>

                    <div style={{ marginBottom: 24 }}>
                        <label style={{ display: 'block', marginBottom: 4, fontSize: 13, color: '#333' }}>
                            Password
                        </label>
                        <PasswordInput
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            required
                            hideSignal={hideSignal}
                            style={{
                                width: '100%', padding: '8px 12px', border: '1px solid #ddd',
                                borderRadius: 4, fontSize: 14, boxSizing: 'border-box'
                            }}
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={loading}
                        style={{
                            width: '100%', padding: '10px 0', background: '#2A6DB0',
                            color: '#fff', border: 'none', borderRadius: 4,
                            fontSize: 14, fontWeight: 600, cursor: loading ? 'wait' : 'pointer'
                        }}
                    >
                        {loading ? 'Signing in...' : 'Sign In'}
                    </button>
                </form>
            </div>
        </div>
    );
}
